import React from 'react';
import RemoveLastDirectoryPartOf from '../goBackButton';

const About = () => {
    return (
        <div className="container">
            <div className="m-2" style={{ fontSize: '20px', display: 'flex' }}>
                <div className="mr-4">
                    <a
                        href={RemoveLastDirectoryPartOf(window.location.href)}
                        style={{ textDecoration: 'none' }}
                    >
                        <i className="fe fe-arrow-left" />
                    </a>
                </div>
                <div>About</div>
            </div>
            <div className="content">
                <div
                    className="mt-8"
                    style={{ display: 'flex', justifyContent: 'center' }}
                >
                    <img
                        style={{ width: '230px', height: '130px' }}
                        src="./images/kmit_sanjaya_logo.png"
                        alt=""
                    />
                </div>
                <div
                    className="m-4"
                    style={{ display: 'flex', justifyContent: 'center' }}
                >
                    <h2>Version 4.0.0</h2>
                </div>
                <div
                    className="m-4"
                    style={{ display: 'flex', justifyContent: 'center' }}
                >
                    <img
                        style={{ width: '230px' }}
                        src="./images/sanjaya_about.jpeg"
                        alt=""
                    />
                </div>
                <div
                    className="mt-6"
                    style={{ display: 'flex', justifyContent: 'center' }}
                >
                    <h4>Released in Q4-2021</h4>
                </div>
            </div>
        </div>
    );
};

export default About;
